var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeadFish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.959,
    height: 31.732,
    viewBox: "0 0 62.959 31.732",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.959,
    height: 31.732,
    fill: "#acffe1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.192,47.67c-.31-.578-.605-1.058-.834-1.567a10.758,10.758,0,0,1,.247-8.84A11.957,11.957,0,0,1,164.2,30.4c-.04-.059-.061-.112-.077-.111a64.066,64.066,0,0,0-10.836,1.387,26.437,26.437,0,0,0-11.422,6.258c-1.5,1.359-2.86,2.872-4.28,4.32a1.545,1.545,0,0,0-.325.529,12.6,12.6,0,0,1,12.409-.582,53.577,53.577,0,0,1,8.524,5.468",
    transform: "translate(-118.126 -26.564)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.484,53.628c1.718-.159,3.882-.333,6.038-.575a8.639,8.639,0,0,0,1.888-.522,1.36,1.36,0,0,0,.953-1.48,7.19,7.19,0,0,0-1.077-3.111A32.047,32.047,0,0,0,8.016,37.407a13.059,13.059,0,0,0-1.324-.776,1.7,1.7,0,0,0-2.286.361,18.314,18.314,0,0,0-2.167,2.883,15.555,15.555,0,0,0-2.213,8.76,7.564,7.564,0,0,0,.286,1.692A4,4,0,0,0,4.178,53.3c1.614.128,3.232.2,5.306.326m-.977-2.963a3.861,3.861,0,1,1,.069-7.71,3.86,3.86,0,1,1-.069,7.71m7.608-.372c.663.26.861.622.468,1.085l-.468-1.085",
    transform: "translate(44.592 -31.875)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.353,144.64c4.475,3.26,8.895,6.631,14.654,7.308a14,14,0,0,0-1.8,6.51,7.185,7.185,0,0,1,4.073-4.365c-.463-.364-1.071-.63-1.317-1.091a5.107,5.107,0,0,1-.248-1.752l.188-.02.061.867h5.887l.088-.2a11.719,11.719,0,0,1-4.792-5.381,1.955,1.955,0,0,0-.2.339,3.107,3.107,0,0,1-2.973,2.418,13.849,13.849,0,0,1-7.9-1.6c-1.827-.92-3.575-1.995-5.358-3l-.3-.168-.068.138",
    transform: "translate(-149.94 -126.725)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.146,177.544c-.255.02-.513.019-.764.063a35.059,35.059,0,0,1-9.6.537c-1.121-.113-2.237-.271-3.354-.417-1.046-.137-1.389.161-1.386,1.224,0,.123,0,.246.008.369.071,2.077.643,2.7,2.862,2.859a13.03,13.03,0,0,0,6.009-1.332c1.882-.8,3.709-1.733,5.553-2.621a6,6,0,0,0,.746-.5l-.07-.178",
    transform: "translate(33.138 -155.703)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.955,56.977a4.923,4.923,0,0,1-.188-5.244c-.115-.082-.195-.146-.281-.2-2.062-1.293-2.591-3.237-2.263-5.5a19.4,19.4,0,0,1,5.237-11.015l-.073-.146a17.968,17.968,0,0,0-2.419,1.536,14.156,14.156,0,0,0-4.938,9.343c-.289,2.629.388,4.9,2.8,6.35.352.212.317.47.265.782a3.728,3.728,0,0,0,.422,2.733,18.511,18.511,0,0,0,1.192,1.5l.243-.141",
    transform: "translate(-83.752 -30.586)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.111,134.389c2.267-1.266,4.261-2.694,4.992-5.3-1.158-.732-3.869-.368-5.279.712l2.267-.189.073.23c-1.1.5-2.2,1.006-3.316,1.485-1.053.453-2.2.781-2.824,1.847-.477.82-.841,1.705-1.255,2.562l.165.087c.3-.4.607-.8.913-1.2a4.9,4.9,0,0,1,4.258-1.76c.375,0,.467.168.342.509-.118.321-.215.651-.335,1.02",
    transform: "translate(-427.769 -112.871)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.651,64.023c-.225-2.7-1.915-4.471-3.915-6.15.053.365.083.693.152,1.012.1.446-.074.539-.492.469a4.95,4.95,0,0,1-4.093-3.038c-.055-.132-.125-.258-.186-.388a.787.787,0,0,0-.192-.291c.121,1.708.452,3.3,2.023,4.356,1.274.854,2.509,1.766,3.76,2.654.079.056.145.131.357.327l-2.378-.622a5.744,5.744,0,0,0,4.964,1.671",
    transform: "translate(-424.09 -48.793)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.21,111.378a16.3,16.3,0,0,1,5.3,3.964c-.159-.285-.314-.571-.477-.853-.429-.746-.839-1.5-1.3-2.231a1.627,1.627,0,0,1-.008-1.854c.39-.62.863-1.188,1.322-1.81l-4.859,2.608.017.177",
    transform: "translate(-335.636 -95.234)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.4,111.322l-4.3,2.3a15.251,15.251,0,0,1,4.585,3.289c-.092-.175-.18-.353-.278-.525-.356-.621-.688-1.259-1.083-1.855a1.472,1.472,0,0,1,.013-1.775c.314-.47.671-.911,1.063-1.436",
    transform: "translate(-375.222 -97.627)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.739,3.472c.56-1.013,1.283-.717,2.018-.4A7.031,7.031,0,0,0,160.115,0a5.153,5.153,0,0,1,1.624,3.471",
    transform: "translate(-120.496 -0.001)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.911,15.629a5.768,5.768,0,0,0-2.411-2.14l1.048,2.27c.3-.457.807-.42,1.363-.13",
    transform: "translate(-161.25 -11.83)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.044,25.923l.649,1.438,1.062-.2-1.648-1.339-.063.1",
    transform: "translate(-193.728 -22.648)",
    fill: "#acffe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.115,38.967l.711-.341-1.271-.671-.049.092.609.92",
    transform: "translate(-217.439 -33.285)",
    fill: "#acffe1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadFish);
export default __webpack_public_path__ + "static/media/deadFish.9237e0597b436514084b45bdb785a2f1.svg";
export { ForwardRef as ReactComponent };